import { SchedulablePresenter, EnthusiastPresenter } from 'shared/presenters'
import { Schedulable_Membership_Restrictions } from 'shared/presenters/graphqlTypes'

const enthusiastHasRequiredMembership = ({
  enthusiast,
  schedulableId
}: {
  enthusiast?: EnthusiastPresenter
  schedulableId: SchedulablePresenter['id']
}) => {
  // Enthusiast membership subscriptions (only active or trialing are returned by query)
  const userSubscriptions =
    enthusiast?.stripe_customer_accounts?.[0]?.membership_subscriptions

  if (!userSubscriptions) {
    return false
  }

  // Schedulable Ids from the enthusiast membership subscriptions
  const userSubscriptionsSchedulableIds: Schedulable_Membership_Restrictions['schedulable_id'][] =
    []

  userSubscriptions?.forEach(subscription => {
    subscription?.membership_price?.membership_product?.schedulable_membership_restrictions?.forEach(
      restriction => {
        userSubscriptionsSchedulableIds.push(restriction.schedulable_id)
      }
    )
  })

  const userHasMembershipAssociatedWithProduct =
    userSubscriptionsSchedulableIds.includes(schedulableId)

  return userHasMembershipAssociatedWithProduct
}

export default enthusiastHasRequiredMembership
